<div *ngIf="report">

    <div [style]="styles.header.page">
      <div [style]="styles.header.text"><b>OVERVIEW OF YOUR COACHING STRENGTHS</b></div>
  
      <div [style]="styles.header.line"></div>
    </div>
  
    <div [style]="styles.container_padding">
  
        <h2 [style]="styles.general_h2"><b>Your Primary Coaching Style</b></h2>
  
        <p [style]="styles.paragraph">Your primary coaching style is the 
          <span [style]="styles.highlight">{{ report.primaryCoachingStyle }}</span>.</p>
  
        <p [style]="styles.paragraph" [innerHtml]="html"></p>
  
    </div>
  
  </div>